export default __webpack_public_path__ + "static/media/medium_top.e77dce26.png";